import { LoadableAfterPaint } from '@confluence/loadable';

export const SitePermissionsPageLoader = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-componentsSitePermissionsPage" */ '../src/components/SitePermissions/SitePermissionsPage.tsx'
			)
		).SitePermissionsPage,
});
